import {
  IDEAL_HEATING_SUPPORT_NUMBER,
  IDEAL_SUPPORT_NUMBER,
} from 'darwin_core/utils/consts.js';

import HaloDevices from '../components/HaloDevices.jsx';

// The no-cloud-licence screen — a port of the app's Property screen for a home
// whose thermostat is a non-connected version (app/src/screens/Property/Property.js,
// gated on isCloudSupported → home.cloudSupported → the API's connectedDevice).
// There is nothing to control from the cloud on such a home, so this stands in
// place of the tiles and actions, with the app's illustration and its copy.
//
// The support number IS dialable here, and only here: an offline interface is
// something the owner can fix themselves (see components/OfflineHelp), while a
// licence is a sale — the whole point of the screen is to get them to that call.
// The two constants are the same number in the app's two spellings: one dialable,
// one formatted for reading.
//
// It renders as the Property screen's BODY rather than a whole screen, so the
// burger menu (Help, Logout) and the home selector stay: unlike the app, the web
// has no way out of a screen that replaces everything, and a second home on the
// account may well be connected.
//
// The illustration and the words are separate blocks so the two can sit SIDE BY
// SIDE on a wide screen and stack on a narrow one (see .non-connected), where the
// illustration takes the zone dial's size and column. The app is phone-only and
// stacks always; strung down a desktop column the same copy reads as five
// stranded lines.
export default function NonConnectedNotice() {
  return (
    <section className="non-connected">
      <div className="non-connected__art">
        <HaloDevices />
      </div>
      <div className="non-connected__body">
        <h3 className="non-connected__title">
          Sorry, you don't have access to this feature
        </h3>
        <p className="non-connected__text">
          The Halo thermostat you have installed is a non connected version.
        </p>
        <p className="non-connected__text">
          Good news! You can upgrade to a Wi-Fi enabled version without changing
          your thermostat.
        </p>
        <p className="non-connected__contact">
          Please contact Ideal Customer Support for further information:
        </p>
        <a
          className="non-connected__phone"
          href={`tel:${IDEAL_SUPPORT_NUMBER}`}
        >
          <span className="non-connected__phone-label">
            Ideal Customer Support
          </span>
          <span className="non-connected__phone-number">
            {IDEAL_HEATING_SUPPORT_NUMBER}
          </span>
        </a>
      </div>
    </section>
  );
}
